import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  padding: 50px;
`;

export const Title = styled.div`
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  color: #D40020;
  margin-top: 25px;
`;

export const Link = styled.a`
  font-family: Poppins-Bold;
  font-style: normal;
  font-weight: bold;
  background: #D40020;
  color: #fff;
  margin-top: 40px;
  padding: 10px 20px;
  border-radius: 20px;
  min-width: 60%;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
`;

export const Plate = styled.div`
  font-family: Poppins-Regular;
  font-style: normal;
  font-size: 13.981px;
  text-align: center;
  color: #000;
`;

export const VehicleDescription = styled.div`
  font-family: Poppins-Regular;
  font-style: normal;
  font-size: 13.981px;
  text-align: center;
  color: #000;
  margin-top: 20px;
`;

export const Description = styled.div`
  font-family: Poppins-Regular;
  font-style: normal;
  font-weight: normal;
  font-size: 13.9818px;
  line-height: 19px;
  text-align: center;
  color: #000;
  margin-top: 15px;
`;

export const Wrapper = styled.div`
  border: 2px solid #C4C4C4;
  box-sizing: border-box;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 40px 100px;
  margin-top: 40px;
  position: relative;
  min-width: 500px;

  @media screen and (max-width: 767px) {
    border: 0;
  }

  @media screen and (min-width: 800px) {
    max-width: 550px;
  }
`;

export const SuccessImg = styled.img`
  width: 150px;
`;

export const CenteredCarImage = styled.img`
  width: 118px;
`;

export const CarImage = styled.img`
  width: 160px;
  position: absolute;
  left: -100px;
  top: 50px;

  @media screen and (max-width: 767px) {
    left: 50px;
    width: 100px;
  }
`;

export const SideBuyBag = styled.img`
  width: 160px;
  position: absolute;
  left: -25px;
  top: 250px;

  @media screen and (max-width: 767px) {
    left: 50px;
    width: 100px;
  }
`;

export const CardImage = styled.img`
  width: 270px;
  position: absolute;
  right: -100px;
  bottom: -10px;

  @media screen and (max-width: 767px) {
    width: 250px;
    left: 300px;
    bottom: 50px;
  }
`;
